export const typeOfTreeViewDialog = 'typeOfTreeViewDialog';
